/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { FormControl,  TextField, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LABEL_BTN_CANCEL, LABEL_BTN_SAVE, UNKNOWN_ERR } from '../../constants/constant';
import Button from '../CustomButton/Button';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import Autocomplete from '@mui/material/Autocomplete';
import { getConfigurationList, getConfigurationFields,saveClientConfiguration } from 'src/services/clientService'
import type {clientConfigType,clientConfigListType} from '../types/types';
interface PropsType {
    clientId: number | 0;
    closeModal: (status: string | null) => void;
    clientName: string;
    formValueUpdated: (value: boolean) => void;
}


function ClientConfigurationMapping({ clientId, closeModal, clientName, formValueUpdated }: PropsType):JSX.Element {
    const [configTypeDropdownArr, setConfigTypeDropdownArr] = useState<clientConfigType[]>([]);
    const [clientConfigurationList, setClientConfigurationList] = useState<clientConfigType[]>()
    const [clientConfigurationMappingArr, setClientConfigurationMappingArr] = useState<clientConfigListType[]>();
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [isSaveLoading, setIsSaveLoading] = useState<boolean>(false)
    // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
    const [errors, setErrors] = useState<{ [key: number]: { configType?: string; configName?: string; combination?: string; configValue?: string } }>({});
    const is1366x768 = useMediaQuery('(width:1366px)');
     
  
    useEffect(() => {
        setIsDataLoading(true)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        void getConfigurationFields().then((res: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (res.status === 200) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (res.data.result === 1) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const data = res.data.data;

                    setClientConfigurationList(data)

                    // Get unique configType array
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                    const configTypeArray = data
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
                        .map((item: clientConfigListType) => item.configType)
                        .filter((value: string, index: number, self: string) => self.indexOf(value) === index);

                        setConfigTypeDropdownArr(configTypeArray);
                }
            }
        });

        void getConfigurationList(clientId as number).then((res) => {
            if (res.status === 200) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (res.data.result === 1) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    setClientConfigurationMappingArr(res.data.data);
                } else {
                    setClientConfigurationMappingArr([
                        {
                            configName: '',
                            configType: '',
                            configValue: '',
                        },
                    ]);
                }

                setIsDataLoading(false)
            }
        });
    }, [clientId]);

    const handleAddMapping = () : void=> {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        setClientConfigurationMappingArr((prevArr: clientConfigListType) => [
            // @ts-ignore
            ...prevArr,
            { configType: '', configName: '', configValue: '' }, // Add new empty configuration object
        ]);

        formValueUpdated(true)
    };

    const handleDeleteMapping = (index: number) : void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        if (clientConfigurationMappingArr.length <= 1) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            NotificationManager.error('Cannot delete the last configuration row.'); // Alert the user
            return; // Exit the function to prevent deletion
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        setClientConfigurationMappingArr((prevArr: any) => prevArr.filter((_: any, i: number) => i !== index));
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[index]; // Remove error for the deleted row
            return updatedErrors;
        });
        formValueUpdated(true)
    };

    const handleChange = (index: number, field: string, value: string): void => {
        // @typescript-eslint/ban-ts-comment
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const updatedArr : clientConfigListType[]= [...clientConfigurationMappingArr];
        if(field === "configType") {
            updatedArr[index] = {
                ...updatedArr[index],
                [field]: value, // Update the specific field (configType, configName, or configValue)
                configName: ''
            };
        } else {
            updatedArr[index] = {
                ...updatedArr[index],
                [field]: value, // Update the specific field (configType, configName, or configValue)
            };
        }
        
        setClientConfigurationMappingArr(updatedArr);

        // Validation Logic
        setErrors((prevErrors) => ({
            ...prevErrors,
            [index]: {
                ...prevErrors[index],
                [field]: '', // Clear the error for the specific field
            },
        }));

        const currentErrors = { ...errors };

        // Check for duplicates in the entire array
        const existingCombination = updatedArr.some((item, i) =>
            i !== index && item.configType === updatedArr[index].configType && item.configName === updatedArr[index].configName
        );

        if (existingCombination) {
            currentErrors[index] = { ...currentErrors[index], combination: 'Duplicate config type and name combination' };
        } else {
            delete currentErrors[index]?.combination; // Clear error if no duplicate
        }

        // Check for duplicate configValue
        if (field === 'configValue') {
            const duplicateIndex = updatedArr.findIndex((item, i) => i !== index && item.configValue.toLowerCase() === value.toLowerCase());
            if (duplicateIndex !== -1) {
                currentErrors[index] = { ...currentErrors[index], configValue: 'Duplicate config value entered' };
            } else {
                delete currentErrors[index]?.configValue; // Clear error if no duplicate
            }
        }

        if (field === 'configType') {
            if(value === "") {
                currentErrors[index] = { ...currentErrors[index], configType: 'Please select config type' };
            } else {
                delete currentErrors[index]?.configType;
            }
        }

        if (field === 'configName') {
            if(value === "") {
                currentErrors[index] = { ...currentErrors[index], configName: 'Please select config name' };
            } else {
                delete currentErrors[index]?.configName;
            }
        }

        if (field === 'configName' && (value !== "")) {
            const isValidConfigName = getConfigNamesForType(updatedArr[index].configType).includes(value);
            if (!isValidConfigName) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [index]: { ...prevErrors[index], configName: 'Config Name is not valid for the selected Config Type.' },
                }));
            }
        }

        setErrors(currentErrors);
        formValueUpdated(true)
    };

    
    // Save function that includes validation check
    const handleSave = () : void=> {

        console.log(232323);
        let hasErrors = false;
// @ts-ignore
        clientConfigurationMappingArr.forEach((row: any, index: any) => {
            const rowErrors = { configType: '', configName: '', configValue: '', combination: '' };

            // Validate that configType, configName, and configValue are not blank
            if (!row.configType) {
                rowErrors.configType = "Config type, config name and config value are required.";
                hasErrors = true;
            }
            if (!row.configName) {
                rowErrors.configName = "Config type, config name and config value are required.";
                hasErrors = true;
            }
            if (!row.configValue || row.configValue.trim() === "") {
                rowErrors.configValue = "Config type, config name and config value are required.";
                hasErrors = true;
            }

            // Check for duplicate configType and configName combinations or configValue duplicates
            if (!hasErrors) {
                // @ts-ignore
                for (let i = 0; i < clientConfigurationMappingArr.length; i++) {
                    if (i !== index) {
                        // @ts-ignore
                        const otherRow = clientConfigurationMappingArr[i];
                        if (
                            row.configType === otherRow.configType &&
                            row.configName === otherRow.configName
                        ) {
                            rowErrors.combination = "Duplicate config type and name combination";
                            // rowErrors.configName = "Duplicate config type and name combination";
                            hasErrors = true;
                        }
                        if (row.configValue.trim().toLowerCase() === otherRow.configValue.trim().toLowerCase()) {
                            rowErrors.configValue = "Duplicate Config Value entered";
                            hasErrors = true;
                        }
                    }
                }
// @ts-ignore
                const isValidConfigName = getConfigNamesForType(row.configType).includes(row.configName);
                if (row.configType && row.configName && !isValidConfigName) {
                    rowErrors.configName = 'Config Name is not valid for the selected Config Type.';
                    hasErrors = true;
                }
            }

            // Update errors for each row
            setErrors((prevErrors) => ({
                ...prevErrors,
                [index]: rowErrors,
            }));
        });

        if (hasErrors) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            NotificationManager.error('Please resolve the errors before saving'); // Alert or handle as needed
            return;
        }

        const transformedData : clientConfigType = {
            clientId: clientId ?? 0, // Use 0 if clientId is null
            //@ts-ignore
            configList: clientConfigurationMappingArr.map((item: { configName: any; configValue: any; configType: any}) => ({
                configName: item.configName,
                configValue: item.configValue,
                configType: item.configType
            })),
            createdBy: 1 // Use 0 if createdBy is undefined
        };
    
        setIsSaveLoading(true)   
          setIsSaveLoading(true)
        saveClientConfiguration(transformedData)
            .then(
                res => {
                    if (res.status === 200) {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        if (res.data.result === 1) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                            NotificationManager.success("Client configuration saved successfully")
                            setIsSaveLoading(false)
                            formValueUpdated(false)
                            closeModal("save")
                        } else {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                            NotificationManager.error(UNKNOWN_ERR)
                            setIsSaveLoading(false)
                        }
                    }
                }
            )
            .catch(
                error => {
                    console.log("Error", error)
                    setIsSaveLoading(false)
                }
            )
            .finally(() => setIsSaveLoading(false))

    };

    // Filter config names based on the selected config type
   const getConfigNamesForType = (configType: string): string[] => {
    if (!clientConfigurationList) {
        return []; // Return an empty array if the list is not yet loaded
    }
    return clientConfigurationList
        .filter((item: any) => item.configType === configType)
        .map((item: any) => item.configName);
};
    

    const handleAutocompleteFocus = (index: number) : void=> {
        if (errors[index]?.configName) {
            //@ts-ignore
            const updatedMappings = [...clientConfigurationMappingArr];
            updatedMappings[index].configName = ''; // Clear the value on focus if there's an error
            setClientConfigurationMappingArr(updatedMappings);

            setErrors(prevErrors => ({
                ...prevErrors,
                [index]: { ...prevErrors[index], configName: '' },
            }));
        }
    };

    return (
        <>
            <div className="px-[16px] pt-[10px] mb-[75px]">
                <div className="grid">
                    <div className="mb-[20px] w-full relative">
                    <div className="border border-inputborder bg-[#f5f5f5] text-center text-[18px] font-semibold rounded-md p-[7px] text-muted">
           {clientName}
          </div>
                       
                    </div>
                </div>

                <div
                    className="grid gap-2 grid-cols-10"
                    style={{
                        marginBottom: '20px',
                        padding: '10px',
                        background: '#F5F5F5',
                        borderRadius: '6px',
                    }}
                >
                    <div className="col-span-3 w-full relative self-center truncate text-muted font-semibold">Config Type</div>
                    <div className="col-span-3 w-full relative self-center truncate text-muted font-semibold">Config Name</div>
                    <div className="col-span-3 w-full relative self-center">
                        <span className="text-muted font-semibold">Config Value</span>
                    </div>
                    <div className="col-span-1 w-full relative self-center text-center"></div>
                </div>
                {
                    isDataLoading ? <div className='flex justify-center items-center relative top-[20%]'><span className="loading loading-spinner text-primary"></span></div> :
                        <React.Fragment>
                            {clientConfigurationMappingArr != undefined && clientConfigurationMappingArr.map((field: any, index: number) => {
                                return (
                                    <div key={index} style={{ marginBottom: '30px' }}>
                                        <div className="grid gap-2 grid-cols-10"  >
                                            <div className="col-span-3 w-full relative self-center truncate text-muted pl-[15px] pt-[5px]">
                                            <FormControl className="form-dropdown w-[90%]" error={!!errors[index]?.configType || !!errors[index]?.combination}>
                                                <Autocomplete
                                                    id={`config-type-${index}`}
                                                    //@ts-ignore
                                                    options={configTypeDropdownArr || []}
                                                    value={field.configType || null}
                                                    isOptionEqualToValue={(option, value) => option === value}
                                                    onChange={(event, newValue) => handleChange(index, 'configType', newValue)}
                                                    disableClearable
                                                    filterOptions={(options, { inputValue }) => {
                                                        if (field.configType && !inputValue) {
                                                            return options.filter(option => 
                                                                option.toLowerCase().includes(field.configType.toLowerCase())
                                                            );
                                                        }          
                                                        if (inputValue) {
                                                            return options.filter(option => 
                                                                option.toLowerCase().includes(inputValue.toLowerCase())
                                                            );
                                                        }        
                                                        return options;
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField 
                                                            {...params} 
                                                            label="Type"
                                                            error={!!errors[index]?.configType || !!errors[index]?.combination}
                                                        
                                                            onChange={(e) => {
                                                                if (!e.target.value) {
                                                                    handleChange(index, 'configType', '');
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                    getOptionLabel={(option) => {
                                                        if (is1366x768) {
                                                            const maxLength = 20;
                                                            if (option?.toString().length > maxLength) {
                                                                return option?.toString().slice(0, maxLength) + '...';
                                                            }
                                                        }
                                                        return option?.toString() || '';
                                                    }}
                                                    // freeSolo
                                                    openOnFocus
                                                />
                                            </FormControl>
                                            </div>
                                            <div className="col-span-3 w-full relative self-center truncate text-muted font-semibold pt-[5px]">
                                            <FormControl className="form-dropdown w-[90%]" error={!!errors[index]?.configName || !!errors[index]?.combination}>
                                                <Autocomplete
                                                    id={`config-name-${index}`}
                                                    //@ts-ignore
                                                    options={getConfigNamesForType(field.configType)}
                                                    value={field.configName || null}
                                                    // isOptionEqualToValue={(option, value) => option === value}
                                                    onChange={(event, newValue) => handleChange(index, 'configName', newValue)}
                                                    onFocus={() => handleAutocompleteFocus(index)}
                                                    disableClearable
                                                    filterOptions={(options, { inputValue }) => {
                                                        if (field.configName && !inputValue) {
                                                            return options.filter(option => 
                                                                option.toLowerCase().includes(field.configName.toLowerCase())
                                                            );
                                                        }          
                                                        if (inputValue) {
                                                            return options.filter(option => 
                                                                option.toLowerCase().includes(inputValue.toLowerCase())
                                                            );
                                                        }        
                                                        return options;
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField 
                                                            {...params} 
                                                            label="Name"
                                                            error={!!errors[index]?.configName || !!errors[index]?.combination}
                                                            onChange={(e) => {
                                                                if (!e.target.value) {
                                                                    handleChange(index, 'configName', '');
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                    getOptionLabel={(option) => {
                                                        if (is1366x768) {
                                                            const maxLength = 20;
                                                            if (option?.toString().length > maxLength) {
                                                                return option?.toString().slice(0, maxLength) + '...';
                                                            }
                                                        }
                                                        return option?.toString() || '';
                                                    }}
                                                   
                                                    // freeSolo
                                                    openOnFocus
                                                />
                                            </FormControl>
                                            </div>
                                            <div className="col-span-3 w-full relative self-center truncate text-muted font-semibold pt-[5px]">
                                                <TextField
                                                    id={`config-value-${index}`}
                                                    label="Value"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={field.configValue}
                                                    onChange={(e) => handleChange(index, 'configValue', e.target.value)} // Handle change
                                                    error={errors[index] && !!errors[index].configValue}
                                                    helperText={errors[index] && !!errors[index].configValue}
                                                />

                                            </div>
                                            <div className="col-span-1 w-full relative self-center text-center">
                                                <button type='button' className='btn btn-circle btn-circle-small  bg-[#F9D0D2] disabled:bg-[#F5F5F5] border-none hover:bg-[#ffaeb2] w-[35px] h-[35px] min-h-[35px]' onClick={() => handleDeleteMapping(index)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 19" fill="none">
                                                        <path d="M16.4138 4.40863C13.5622 4.12604 10.6935 3.98047 7.83344 3.98047C6.13792 3.98047 4.44241 4.0661 2.74689 4.23737L1 4.40863" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M5.70996 3.54327L5.89835 2.42149C6.03536 1.60799 6.13812 1 7.5853 1H9.82886C11.276 1 11.3874 1.64224 11.5158 2.43006L11.7042 3.54327" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14.5724 7.11328L14.0158 15.7364C13.9216 17.0808 13.8445 18.1256 11.4554 18.1256H5.95783C3.56869 18.1256 3.49162 17.0808 3.39743 15.7364L2.84082 7.11328" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M7.27686 13.416H10.1284" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M6.56592 9.99219H10.8475" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        {errors[index]?.combination && (
                                            <div className='error' style={{ color: '#ED4B52', marginTop: '5px', marginLeft: '16px' }}>
                                                {errors[index].combination ? errors[index].combination : errors[index].configType}
                                            </div>
                                        )}
                                        {errors[index]?.configValue && (
                                            <div className='error' style={{ color: '#ED4B52', marginTop: '5px', marginLeft: '16px' }}>{errors[index].configValue}</div>
                                        )}
                                        {(errors[index]?.configName && !errors[index]?.configValue) && (
                                            <div className='error' style={{ color: '#ED4B52', marginTop: '5px', marginLeft: '16px' }}>{errors[index].configName}</div>
                                        )}
                                    </div>
                                );
                            })}

                            <div className="mt-[40px] ml-[15px]">
                                <Button
                                    label="Add Configuration"
                                    isGradient
                                    color="primary"
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                                            <path
                                                d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z"
                                                fill="#F13139"
                                            />
                                            <path
                                                d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z"
                                                fill="#F13139"
                                            />
                                        </svg>
                                    }
                                    onClick={handleAddMapping}
                                />
                            </div>
                        </React.Fragment>
                }
            </div>
            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button
                        type="button"
                        className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg=[#f0f0f0] disabled:text-muted"
                        onClick={() => closeModal(null)} disabled={isSaveLoading}
                    >
                        {LABEL_BTN_CANCEL}
                    </button>
                </div>
                <div className="w-full relative col-span-3">
                    <button
                        className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[35px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:opacity-100 capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
                        onClick={handleSave} // Save button with validation check
                        disabled={isSaveLoading}
                    >
                        {!isSaveLoading ? `${LABEL_BTN_SAVE}` : <span className="loading loading-spinner loading-xs text-white"></span>}
                    </button>
                </div>
            </div>
            
        </>
    );
}

export default ClientConfigurationMapping;
